import AlertsPage from "./fleet/AlertsPage";

/**
 * Submenú: Documentos y Vigencia → Alertas de Vencimiento
 * Wrapper del módulo fleet — listado completo de alertas
 * con filtros, selección múltiple, stats y paginación
 */
const AlertasVencimiento = () => {
  return <AlertsPage />;
};

export default AlertasVencimiento;
